import { render, staticRenderFns } from "./DocumentsNew.vue?vue&type=template&id=05007fd2&scoped=true"
import script from "./DocumentsNew.vue?vue&type=script&lang=ts"
export * from "./DocumentsNew.vue?vue&type=script&lang=ts"
import style0 from "./DocumentsNew.vue?vue&type=style&index=0&id=05007fd2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05007fd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05007fd2')) {
      api.createRecord('05007fd2', component.options)
    } else {
      api.reload('05007fd2', component.options)
    }
    module.hot.accept("./DocumentsNew.vue?vue&type=template&id=05007fd2&scoped=true", function () {
      api.rerender('05007fd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/managerDetails/DocumentsNew.vue"
export default component.exports